export const getFileName = (filePath: string) => {
  const filePathArr = filePath.split('/') || [];
  return filePathArr[filePathArr.length - 1];
};
